import React from "react";
import ButtonComp from "./ButtonComp";

export default function FeatureSection({
  title,
  highlightText,
  cards = [],
  bottomText,
  ctaText,
  onCtaClick,
}) {
  return (
    <section className="feature-app-section">
      <div className="custom-container text-center">
        {/* TITLE */}
        <h2
          className="top-section-text FS40FW600"
          dangerouslySetInnerHTML={{
            __html: `${title} <br/><span class="text-success">${highlightText}</span>`,
          }}
        />

        {/* CARDS */}
        <div className="row justify-content-center mt-5 plus-sans">
          {cards.map((card, i) => (
            <div className="col-lg-3 col-md-6 mb-4" key={i}>
              <div className="feature-card h-100">
                {/* ICON */}
                <div className="feature-section-icon">
                  <img src={card.icon} alt={card.title} />
                </div>

                {/* CONTENT */}
                <h5 className="mb-1 FS24FW500 fw-700">{card.title}</h5>
                <p className="FS16FW500">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* BOTTOM TEXT */}
        {bottomText && <p className="plus-sans FS16FW500 fw-700 mt-4">{bottomText}</p>}

        {/* CTA */}
        {ctaText && (
          // <button className="primary-btn mt-3 plus-sans FS16FW500 fw-700" onClick={onCtaClick}>
          //   {ctaText} <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
          // </button>
           <ButtonComp link={onCtaClick} btnText={ctaText} img="/images/web-new-images/new-dark-arrow.svg"/>
        )}
      </div>
    </section>
  );
}
